import Context from "../../../context/Context";
import FieldNames from "../../../aiim/datasets/FieldNames";
import * as aiimUtil from "../../../../src/aiim/util/aiimUtil";


export function getSiteId () {

    return new Promise((resolve, reject)=>{
        const datasets = Context.instance.aiim.datasets;
        if(!datasets) return;

        // if no sites layer, don't show site filter
        const sitesLayer = Context.instance.aiim.datasets.sites;
        if(!sitesLayer) return;

        // if sites layer present but has no data, don't show site filter
        const isSitesById = datasets && datasets.levels 
          && datasets.levels_data && datasets.levels._data.sitesById;
        if(isSitesById && Object.keys(datasets.levels._data.sitesById).length === 0) return; 
   
        // referenceLayer required to get home location if any
        const referenceLayer = Context.getInstance().session.referenceLayer;
        const home = referenceLayer && referenceLayer.homeLocation && referenceLayer.homeLocation.name;
        
        // check for active site (floor aware webmap)
        const views = Context.instance.views;
        const isActiveWidgetSite = views && views.floorFilter 
            && views.floorFilter.activeWidget && views.floorFilter.activeWidget.site;
        // check for active site (non-floor aware maps)
        let isActiveFacilityInfoSite;
        const activeFacilityInfo = Context.getInstance().aiim.facilityMode 
                                    && Context.getInstance().aiim.facilityMode.activeFacilityInfo;
        if(activeFacilityInfo && activeFacilityInfo.zeroVOLevel && activeFacilityInfo.zeroVOLevel.siteId) {
          isActiveFacilityInfoSite = activeFacilityInfo.zeroVOLevel.siteId;
        } else if(Context.getInstance().aiim.facilityMode && Context.getInstance().aiim.facilityMode.siteId) {
          isActiveFacilityInfoSite = Context.getInstance().aiim.facilityMode.siteId;
        }
       
        if (isActiveWidgetSite) {
        // if site has been selected from floor filter (floor aware webmap)
    
          const activeSite = Context.instance.views.floorFilter.activeWidget.site;
          if(activeSite) {
            resolve(activeSite);
            return;
          }
        } else if(isActiveFacilityInfoSite) {
          // if site has been selected (non-floor aware maps)
    
          const activeSite = isActiveFacilityInfoSite;
          if(activeSite) {
            resolve(activeSite);
            return;
          }
        } else {
          let locationGeometry;
          const siteObj = Context.instance.aiim.datasets.sites;
    
          // If current browser location is accessible use it to get the nearest site_id 
          if (navigator && navigator.geolocation && navigator.geolocation.getCurrentPosition) {
            let currentBrowserLocation;

            function getCurrentPosition(){
              const promise = new Promise((resolve,reject) => {
                navigator.geolocation.getCurrentPosition(
                  (position) => {
                    resolve(position);
                  },
                  (positionError) => {
                    resolve("block");
                  },
                );
              });
              return promise;
            }

            getCurrentPosition()
            .then(position => {
              if(position === "block") {
                if(home) {
                  getSiteIdByHomeLocation(siteObj)
                  .then((siteId)=> {
                    resolve(siteId);
                    return;
                  })
                  .catch((error)=> {
                    console.warn("Error querying site by map extent");
                    resolve(null);
                  })
                }else {
                  getSiteIdByMapExtent(siteObj)
                  .then((siteId)=> {
                    resolve(siteId);
                    return;
                  })
                  .catch((error)=> {
                    console.warn("Error querying site by map extent");
                    resolve(null);
                  })
                }
              }else {
                if(position) currentBrowserLocation = position.coords;
                if(currentBrowserLocation) {
                  if(currentBrowserLocation.latitude && currentBrowserLocation.longitude) {
                    const lib = Context.getInstance().lib;
                    locationGeometry = new lib.esri.Point({
                      latitude: currentBrowserLocation.latitude,
                      longitude: currentBrowserLocation.longitude,
                      z: 0,
                      spatialReference: lib.esri.SpatialReference.WGS84
                    });
                    if(!locationGeometry) {
                      resolve(null);
                      return;
                    }
                    querySiteByGeometry(siteObj, locationGeometry)
                    .then((siteId)=> {
                      resolve(siteId);
                      return;
                    })
                    .catch(error => {
                      console.warn("Error querying site by geometry");
                      console.error(error);
                      resolve(null);
                    })
                  }
                }
              }
            })
            .catch(()=>{
              console.warn("Error querying site by map extent");
              resolve(null);
            })
          } else if(home) {
              getSiteIdByHomeLocation(siteObj)
              .then((siteId)=> {
                if(siteId) {
                  resolve(siteId);
                  return;
                }else {
                  getSiteIdByMapExtent(siteObj)
                  .then((siteId)=> {
                    resolve(siteId);
                    return;
                  })
                  .catch((error)=> {
                    console.warn("Error in getting site-id by map extent", error);
                    resolve(null);
                  })
                }
              })
              .catch((error)=> {
                console.warn("Error in getting site-id by map extent", error);
                resolve(null);
              })
          } else {
            getSiteIdByMapExtent(siteObj)
            .then((siteId)=> {
              resolve(siteId);
              return;
            })
            .catch((error)=> {
              console.warn("Error in getting site-id by map extent", error);
              resolve(null);
            })
          }
        }
      })
    }

  export function getSiteIdByHomeLocation(siteObj) {

    // If current location is blocked; get site-id using home location
    return new Promise ((res, rej) =>{
      const referenceLayer = Context.getInstance().session.referenceLayer;
      const homeLocation = referenceLayer.homeLocation;
      if(homeLocation && homeLocation.searchResult 
        && homeLocation.searchResult.feature && homeLocation.searchResult.feature.geometry) {
          const geometry = homeLocation.searchResult.feature.geometry;

          // if homeLocation is a point 
          if(geometry.type === "point") {
            querySiteByGeometry(siteObj, geometry)
            .then((siteId)=> {
              return siteId;
            })
            .catch(error => {
              console.warn("Error querying site by geometry");
              console.error(error);
            })
          }
          // if homeLocation is a unit; geometry type is polygon
          if(geometry.type === "polygon") {
            querySiteByGeometry(siteObj, geometry.centroid)
            .then((siteId)=> {
              res(siteId);
              return;
            })
            .catch(error => {
              console.warn("Error querying site by geometry");
              rej(error);
            })
          }
        }
    })
  }

  export function getSiteIdByMapExtent(siteObj) {
    return new Promise ((res, rej) =>{
      const activeView = Context.getInstance().views.activeView;
      // If current browser location is blocked and no home location, 
      // use the current map extent to get the nearest site_id
  
      if(activeView && activeView.type === "2d" && activeView.extent) {
        let locationGeometry = activeView.extent;
  
        // check if spatialReference is WebMercator
        if(Context.instance.views.activeView.spatialReference.isWebMercator) {}
        else if(locationGeometry) locationGeometry = Context.instance.lib.esri.webMercatorUtils.geographicToWebMercator(locationGeometry);
        if(!locationGeometry) return;
        querySiteByGeometry(siteObj, locationGeometry)
        .then((siteId)=> {
          res(siteId);
          return;
        })
        .catch(error => {
          console.warn("Error querying site by geometry");
          rej(error);
        })
      }
    })
  }

  export function querySiteByGeometry(siteObj, locationGeometry){
    return new Promise ((resolve, reject)=>{
      siteObj.queryByGeometry(locationGeometry)
      .then((res)=> {
        if(res && res.features && res.features.length === 0) {
          //If the user's map extent is outside the site extent, select the site nearest to the current map extent
          //If the user's location is outside the site extent, select the site nearest to the current location
          
          let pt1;

          // if browserLocation geometry is passed; type is point
          if(locationGeometry.type === "point") pt1 = locationGeometry;
          // if map extent is passed; type is extent
          if(locationGeometry.type === "extent") pt1 = locationGeometry.center;

          // if web-map is floor aware
          const sitesById = Context.instance.aiim.datasets.levels._data.sitesById;
          if(sitesById && Object.keys(sitesById).length > 0) {
            let sites = [];
            for (const [key, value] of Object.entries(sitesById)) {
              sites.push(value.feature);
            }
            const siteId = getNearestSite(pt1, sites);
            resolve(siteId);
            return;
          }else{
            // if web-map is non-floor aware
            siteObj.queryAll()
            .then(res => {
              if(!res || !res.features || res.features.length === 0) {
                resolve(null);
                return;
              }
              const siteId = getNearestSite(pt1, res.features);
              resolve(siteId);
              return;
            })
            .catch(error => {
              console.warn("Error querying all sites");
              console.error(error);
              reject(error);
            })
          }
        }
        else if(res && res.features && res.features.length === 1) {
          // if only one site found; use it
          const siteId = aiimUtil.getAttributeValue(res.features[0].attributes,FieldNames.SITE_ID);
          resolve(siteId);
          return;
        }else if(res && res.features && res.features.length > 1) {
          // if more than one site returned, set site_id to the nearest one
          
          let pt1;
          // if browserLocation geometry is passed; type is point
          if(locationGeometry.type === "point") pt1 = locationGeometry;
          // if map extent is passed; type is extent
          if(locationGeometry.type === "extent") pt1 = locationGeometry.center;
          
          const siteId = getNearestSite(pt1, res.features);
          resolve(siteId);
          return;
        }
      })
      .catch(error => {
        console.warn("Error querying site by geometry");
        reject(error);
      })
    })
  }

  export function getNearestSite (pt1, features) {
    let siteId, distance;
    features.forEach(feature => {
        //each feature is a site so geometry type is polygon; thus considering centroid
        const pt2 = feature.geometry && feature.geometry.centroid;
        if(pt1 && pt2) {
            let temp = Math.sqrt(Math.pow((pt2.x - pt1.x),2) + Math.pow((pt2.y - pt1.y),2));
            if(!distance) {
              distance = temp;
              siteId = aiimUtil.getAttributeValue(feature.attributes,FieldNames.SITE_ID);
            }
            if(temp < distance) {
              distance = temp;
              siteId = aiimUtil.getAttributeValue(feature.attributes,FieldNames.SITE_ID);
            }
        }
    })
    return siteId;
  }
 